import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/registration`

const ListaEnvioEmailHttp = {
  async salvarLista(id, nome, ativo, operations_center_id) {
    try {
      const url = BASE_URL + `/lista-envio-email`
      const response = await authHttp().post(url, { id, nome, ativo, operations_center_id })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async excluirLista(lista_id) {
    try {
      const url = BASE_URL + `/lista-envio-email/${lista_id}`
      await authHttp().delete(url)
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async getListas(operation_center_id) {
    try {
      const url = BASE_URL + `/lista-envio-email/${operation_center_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async getEmails(lista_envio_id) {
    try {
      const url = BASE_URL + `/lista-envio-email/email/${lista_envio_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async salvarEmail(id, lista_envio_id, email, name, tps) {
    try {
      const url = BASE_URL + `/lista-envio-email/email`
      const response = await authHttp().post(url, { id, lista_envio_id, email, name, tps })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async apagarEmail(email_id) {
    try {
      const url = BASE_URL + `/lista-envio-email/email/${email_id}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default ListaEnvioEmailHttp
